export const splitterStyles = {
    container: {
        boxShadow: '0 0 20px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flex: 1,
        minHeight: 0,
    } as React.CSSProperties,

    leftPanel: {
        backgroundColor: '#ededed',
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
    } as React.CSSProperties,

    rightPanel: {
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
    } as React.CSSProperties,
};